import { LiveAnnouncer } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, inject, Input, OnChanges, OnInit, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatFormField, MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule, Sort } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { RouterLink } from '@angular/router';
import { BlockUIModule } from 'ng-block-ui';

// #region Interfaces (1)

export interface CustomTableColumn {
  // #region Properties (4)

  cellTemplate?: TemplateRef<any>;
  hide?: boolean;
  id: string;
  title: string;
  link?: string | undefined;

  // #endregion Properties (4)
}

// #endregion Interfaces (1)

// #region Classes (1)

@Component({
    selector: 'app-common-table-card',
    standalone: true,
    imports: [
        CommonModule,
        MatCardModule,
        MatFormField,
        MatFormFieldModule,
        ReactiveFormsModule,
        MatTableModule,
        MatInputModule,
        MatSortModule,
        MatPaginatorModule,
        BlockUIModule,
        RouterLink
    ],
    templateUrl: './common-table-card.component.html',
    styleUrls: ['./common-table-card.component.scss']
})
export class CommonTableCardComponent<T> implements OnInit, OnChanges, AfterViewInit {
  // #region Properties (9)

  public columnsToDisplay: string[] = [];
  @Input()
  public data: T[] | null = [];
  public dataSource: MatTableDataSource<T> = new MatTableDataSource<T>([]);
  @Input()
  public displayedColumnObjects: CustomTableColumn[] = [];
  public hasData = false;
  @Input()
  public heading: string = '';

  @Input()
  public filter: boolean = false;
  
  @ViewChild(MatPaginator)
  paginator!: MatPaginator;

  @ViewChild(MatSort)
  sort!: MatSort;

  // #endregion Properties (9)

  // #region Constructors (1)

  constructor() {
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  applyFilter(event: any) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  getLink(column: CustomTableColumn, element: any) : string {
    let result = column.link;

    if (result?.indexOf(":id")! > -1)
    {
      result = result?.replace(":id", element["id"])
    }

    return result!;
  }
  // #endregion Constructors (1)

  // #region Public Methods (2)
  public ngOnChanges(changes: SimpleChanges): void {
    this.columnsToDisplay = this.getDisplayedColumnNames(
      this.displayedColumnObjects
    );
    this.dataSource.data = this.data!;
    this.hasData = this.data!.length > 0;
  
  }

  private _liveAnnouncer = inject(LiveAnnouncer);

  announceSortChange(sortState: Sort) {
    // This example uses English messages. If your application supports
    // multiple language, you would internationalize these strings.
    // Furthermore, you can customize the message to add additional
    // details about the values being sorted.
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }
  
  public ngOnInit(): void {
    this.columnsToDisplay = this.getDisplayedColumnNames(
      this.displayedColumnObjects
    );
      this.dataSource.data = this.data!;
      this.hasData = this.data!.length > 0;
  }

  // #endregion Public Methods (2)

  // #region Private Methods (1)

  private getDisplayedColumnNames(tableOpts: CustomTableColumn[]): string[] {
    const displayedColumns: string[] = tableOpts
      // just for config test
      .filter((column: CustomTableColumn) => !column.hide)
      .map((column: CustomTableColumn) => column.id);

      console.debug("DisplayedColumns", displayedColumns);

    return displayedColumns;
  }

  // #endregion Private Methods (1)
}

// #endregion Classes (1)
